import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homepage',
    templateUrl: './homepage.component.html',
    styleUrl: './homepage.component.sass',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepageComponent {}
